import Home from "../pages/Home.vue";
import Login from "../pages/Login.vue";
import Details from "../pages/Details.vue";
import RegMask from "../pages/RegMask.vue";

export default [
  {
    path: "/",
    name: "home",
    component: Home,

    meta: {
      logged_in_only: true,
      tabName: "Home",
    },
  },
  {
    path: "/details/:id",
    name: "details",
    component: Details,
  },
  {
    path: "/regmask/:id",
    name: "regmask",
    component: RegMask,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
];
